// extracted by mini-css-extract-plugin
module.exports = {"header":"NavigationMenu_header__pMQv0","logo":"NavigationMenu_logo__dOzgs","active":"NavigationMenu_active__la0UI","badge":"NavigationMenu_badge__DWRUa"};